/**
 * An account that cannot batch (an EOA without a 7702 delegation on the network)
 * signs and broadcasts one raw transaction per call, sequentially. Without this the
 * button just says "Signing..." for the whole run and the user has no idea how many
 * more signatures the wallet is going to ask for.
 */
const getSigningProgressText = ({
  signedTransactionsCount,
  totalTransactions,
  defaultText
}: {
  signedTransactionsCount?: number | null
  totalTransactions?: number
  defaultText: string
}): string => {
  if (typeof signedTransactionsCount !== 'number') return defaultText
  if (!totalTransactions || totalTransactions <= 1) return defaultText

  const current = Math.min(Math.max(signedTransactionsCount + 1, 1), totalTransactions)

  return `Signing ${current}/${totalTransactions}...`
}

export { getSigningProgressText }
